import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Page } from 'src/app/classes/page';
import { AuditService } from 'src/app/services/audit.service';
import { AuditStatusService } from 'src/app/services/Auditstatus.service';
import { LiquidationService } from 'src/app/services/liquidation.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-socities-list-for-audit-verification',
  templateUrl: './socities-list-for-audit-verification.component.html',
  styleUrls: ['./socities-list-for-audit-verification.component.scss']
})
export class SocitiesListForAuditVerificationComponent {

  errorMessage: string = '';
  page = new Page();
  statusid: any;
  columnss: any[] = [];
  loading = false;
  rowses: any[] = [];

  constructor(private auditService: AuditService, private route: ActivatedRoute, private auditstatus: AuditStatusService, private toastService: ToastService,
    private router: Router) {
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
    }
  }

  ngOnInit(): void {
    this.columnss = [
      { prop: 'sSocietyName', name: 'Society Name' },
      { prop: 'name', name: 'Departmental Auditor Name' },
      { prop: 'designation', name: 'Designation' },
      { prop: 'mobile', name: 'Mobile No' },
      { prop: 'email', name: 'Email Id' },
      { prop: 'role', name: 'Request Type' },
      { prop: 'status', name: 'Status' },

    ];
    // this.isStatus = this.route.snapshot.paramMap.get('name') as string;
    this.statusid = Number(this.route.snapshot.paramMap.get('id'));
    this.setPage({ offset: 0 });

  }


  setPage(pageInfo: any) {

    this.page.pageNumber = pageInfo.offset;
    var postData = {
      pageSize: this.page.pageSize,
      pageNumber: this.page.pageNumber,
      status: this.statusid,
    };

    this.page.pageNumber = pageInfo.offset;
    this.loading = true;
    this.auditService.getSocietyListForAuditVerification(postData).subscribe({

      next: (response) => {
        this.loading = false;
        if (response.status === 200) {
          this.auditstatus.SetStatus(this.statusid);

          this.rowses = response.data.map((row: any) => ({
            ...row,
            role: row.isLiquidatorRequest ? "Liquidator Audit" : "Auditor",
            isstatus: row.status
          }));
          console.clear();

          this.page.totalRecords = response.totalRecords;
        }

        else {
          this.rowses = [];
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('Error fetching auditors:', error);
      },
    });

  }

  assignSocietyForAuditVerification(iSocietyDetailID: number, transId: number): void {
    this.statusid = this.auditstatus.getStatus();
     
    this.router.navigate(['/audit/view-checklist', iSocietyDetailID, transId]);
  }
}
